import type { FaireProductEntity } from "../../entity_types/product";

export const p_g57p4h5sw9: FaireProductEntity = {
  token: "p_g57p4h5sw9",
  type: "product",
  name: "Calm Down Kit",
  brandToken: "b_ebwob1e8ry",
  brandName: "Carson Dellosa Education",
  imageUrl:
    "https://cdn.faire.com/fastly/d1341f52d6c40f1ca33d740681947e7b8661ff4795e8836081b3ca974c3d0eb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47040b498bd4eb67f7efd9d84916db8585ffd739d621fea014c8e57b4fac88d6.jpeg",
    "https://cdn.faire.com/fastly/7d435c11ddb846daae347d7a5641715f4a9ae47bd177c8f20f1ddfcd438ef94a.jpeg",
    "https://cdn.faire.com/fastly/618fa414980e74a5c34e9bc5fd22bc51a2b291e2a8b337bc32c745943387b272.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Make learning fun—anywhere, anytime—with Carson Dellosa's Be Clever Wherever Calm Down Corner Kit! This portable tool kit for kindergarteners and up is packed with everything you need to support positive thinking, methods of meditation for kids, calming toys for kids, healthy communication, and more. The set includes hands-on manipulatives to reinforce essential social-emotional skills in a fun and engaging way, such as identifying and managing emotions, calming corner strategies, relaxation exercises for anxiety and stress, and more. The kit includes a Spin Wheel, a stretchy string fidget, a tactile strip fidget, a calm down corner reference sticker, and 6 double-sided calming corner charts, all packed in a portable storage tool kit so your child can practice their skills from just about anywhere. Education happens everywhere, and Carson Dellosa strives to provide the tools needed to inspire learning everywhere it happens.",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:34.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
